Vue.component('impact-block', {
    props: ['result', 'score'],
    data() {
        return {
            //
        }
    },
    computed: {
        backgroundColor() {
            // guard on zero values
            var relativeColorAxisPosition = (this.minValue - this.maxValue ) ? ( this.score - this.maxValue) / (this.minValue - this.maxValue ) : 0;
            // init colormix
            let relativeColor = [];
            // mix colors
            for (var i = 0; i < 3; i++) {

                // calculate and store the relative needed high and low colors
                var relativeHigh = parseInt(this.maxColor[i]) * (relativeColorAxisPosition);
                var relativeLow  = parseInt(this.minColor[i]) * (1-relativeColorAxisPosition);

                // calculate floor and hexify
                relativeColor[i] = (Math.floor(relativeHigh+relativeLow)).toString('16');
            }

            // hesjtek and join
            return "#"+(relativeColor.join(''));
        },
        minValue() {
            var min = null;

            this.result.process_data.forEach(row => {

                if (min == null) {
                    min = row.impact;
                }

                min = Math.min(row.impact, min);
            });

            return min;
        },
        maxValue() {
            var max = null;

            this.result.process_data.forEach(row => {

                if (max == null) {
                    max = row.impact;
                }

                max = Math.max(row.impact, max);
            });

            return max;
        },

        minColor: function (){
            return this.convertToColorArray(this.result.impact_driver.map_color_max);
        },

        maxColor: function (){
            return this.convertToColorArray(this.result.impact_driver.map_color_min);
        },
    },
    methods: {
        convertToColorArray(color){
            // init
            let color_arr = [];
            // split up colors for easy mixing
            for (let i = 0; i <= 2; i++) {
                // ignore leading #, split per two chars [0-9a-f]
                color_arr[i] = "0x"+String(color[2*i+1])+String(color[2*i+2]);
            }
            return color_arr;
        }
    },
    mounted() {
        //
    },
    template: `
        <div class="impact-block" :style="{ backgroundColor: backgroundColor}"></div>
    `
});